// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom layout */
.color-palette .react-colorful {
  height: 190px;

  /* padding: 16px; */
  border-radius: 12px;
  /* background: #33333a; */
  /* box-shadow: 0 6px 12px #999; */

  z-index: 1000;

}

.color-palette .react-colorful__saturation {
  /* margin: 15px 0; */

  border-radius: 8px;
  border-bottom: none;
}

.color-palette .react-colorful__hue {
  margin: 15px 0;
  height: 12px;
  border-radius: 8px;
  /* order: -1; */

}
.color-palette .react-colorful__alpha {
  height: 12px;
  border-radius: 8px;
}

.color-palette .react-colorful__hue-pointer,
.color-palette .react-colorful__alpha-pointer {
  width: 25px;
  height: 25px;
}

/* Grayscale layout */
.grayscale-palette .react-colorful {
  height: 195px;
  /* padding: 16px; */
  border-radius: 12px;
  /* background: #33333a; */
  /* box-shadow: 0 6px 12px #999; */

  z-index: 1000;
}

.grayscale-palette .react-colorful__saturation {
  /* margin: 15px 0; */
  border-radius: 8px;
  border-bottom: none;
  background: linear-gradient(to bottom, white, black);
}

.grayscale-palette .react-colorful__hue {
  height: 0px;
  /* order: -1; */
}

.grayscale-palette .react-colorful__alpha {
  margin: 15px 0;
  height: 12px;
  border-radius: 8px;
  /* background: linear-gradient(to right, transparent, var(--brush-solid-color)); */
}

.grayscale-palette .react-colorful__hue-pointer {
  width: 0px;
  height: 0px;
  border: none;
}
.grayscale-palette .react-colorful__saturation-pointer {
  width: 0px;
  height: 0px;
  border-color: var(--brush-solid-color);
  border-width: 15px;
  box-shadow: 0 0 0 2px white;
}
.grayscale-palette .react-colorful__alpha-pointer {
  width: 0px;
  height: 0px;
  border-color: var(--brush-color);
  border-width: 15px;
  box-shadow: 0 0 0 2px white;
}

.colorful-input {
  display: block;
  box-sizing: border-box;
  width: 90px;
  margin: 10px 55px 0;
  padding: 6px;
  border: 0.1px solid #4444;
  border-radius: 10px;
  background: #b9b9b91c;
  outline: none;
  font: inherit;
  text-transform: uppercase;
  opacity: 1;
}

.palette-instruments-position {
  position: absolute;
  right: -82px;
  top: -10px;
  transform: translateY(-100%);
  pointer-events: none;
}

.gradient-instrument-position {
  position: absolute;
  left: 6px;
  top: -10px;
  transform: translateY(-100%);
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/board/tools/Palette/ColorPalette.css"],"names":[],"mappings":";AACA,kBAAkB;AAClB;EACE,aAAa;;EAEb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;;EAEjC,aAAa;;AAEf;;AAEA;EACE,oBAAoB;;EAEpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;;AAEjB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;;EAEjC,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kFAAkF;AACpF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB","sourcesContent":["\r\n/* Custom layout */\r\n.color-palette .react-colorful {\r\n  height: 190px;\r\n\r\n  /* padding: 16px; */\r\n  border-radius: 12px;\r\n  /* background: #33333a; */\r\n  /* box-shadow: 0 6px 12px #999; */\r\n\r\n  z-index: 1000;\r\n\r\n}\r\n\r\n.color-palette .react-colorful__saturation {\r\n  /* margin: 15px 0; */\r\n\r\n  border-radius: 8px;\r\n  border-bottom: none;\r\n}\r\n\r\n.color-palette .react-colorful__hue {\r\n  margin: 15px 0;\r\n  height: 12px;\r\n  border-radius: 8px;\r\n  /* order: -1; */\r\n\r\n}\r\n.color-palette .react-colorful__alpha {\r\n  height: 12px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.color-palette .react-colorful__hue-pointer,\r\n.color-palette .react-colorful__alpha-pointer {\r\n  width: 25px;\r\n  height: 25px;\r\n}\r\n\r\n/* Grayscale layout */\r\n.grayscale-palette .react-colorful {\r\n  height: 195px;\r\n  /* padding: 16px; */\r\n  border-radius: 12px;\r\n  /* background: #33333a; */\r\n  /* box-shadow: 0 6px 12px #999; */\r\n\r\n  z-index: 1000;\r\n}\r\n\r\n.grayscale-palette .react-colorful__saturation {\r\n  /* margin: 15px 0; */\r\n  border-radius: 8px;\r\n  border-bottom: none;\r\n  background: linear-gradient(to bottom, white, black);\r\n}\r\n\r\n.grayscale-palette .react-colorful__hue {\r\n  height: 0px;\r\n  /* order: -1; */\r\n}\r\n\r\n.grayscale-palette .react-colorful__alpha {\r\n  margin: 15px 0;\r\n  height: 12px;\r\n  border-radius: 8px;\r\n  /* background: linear-gradient(to right, transparent, var(--brush-solid-color)); */\r\n}\r\n\r\n.grayscale-palette .react-colorful__hue-pointer {\r\n  width: 0px;\r\n  height: 0px;\r\n  border: none;\r\n}\r\n.grayscale-palette .react-colorful__saturation-pointer {\r\n  width: 0px;\r\n  height: 0px;\r\n  border-color: var(--brush-solid-color);\r\n  border-width: 15px;\r\n  box-shadow: 0 0 0 2px white;\r\n}\r\n.grayscale-palette .react-colorful__alpha-pointer {\r\n  width: 0px;\r\n  height: 0px;\r\n  border-color: var(--brush-color);\r\n  border-width: 15px;\r\n  box-shadow: 0 0 0 2px white;\r\n}\r\n\r\n.colorful-input {\r\n  display: block;\r\n  box-sizing: border-box;\r\n  width: 90px;\r\n  margin: 10px 55px 0;\r\n  padding: 6px;\r\n  border: 0.1px solid #4444;\r\n  border-radius: 10px;\r\n  background: #b9b9b91c;\r\n  outline: none;\r\n  font: inherit;\r\n  text-transform: uppercase;\r\n  opacity: 1;\r\n}\r\n\r\n.palette-instruments-position {\r\n  position: absolute;\r\n  right: -82px;\r\n  top: -10px;\r\n  transform: translateY(-100%);\r\n  pointer-events: none;\r\n}\r\n\r\n.gradient-instrument-position {\r\n  position: absolute;\r\n  left: 6px;\r\n  top: -10px;\r\n  transform: translateY(-100%);\r\n  pointer-events: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
